import { action_options, app_modules } from "helpers/apps_modules_list";
import DispatchViewDetails from "pages/Warehouse/Dispatch/Dispatch/ViewDetails/DispatchViewDetails";
import SalesOrderReturn from "pages/Warehouse/Dispatch/Dispatch/Form/SalesOrderReturn";
import DispatchContainer from "pages/Warehouse/Dispatch/DispatchContainer";
import IssueToLabourForm from "pages/Warehouse/Dispatch/IssueToLabour/Form/IssueToLabourForm";
import IssueToLabourViewDetails from "pages/Warehouse/Dispatch/IssueToLabour/ViewDetails/IssueToLabourViewDetails";
import WarehouseReadyForDispatchEditForm from "pages/Warehouse/Dispatch/ReadyForDispatch/Form/ReadyForDispatchEditForm";
import WarehouseReadyForDispatchForm from "pages/Warehouse/Dispatch/ReadyForDispatch/Form/ReadyForDispatchForm";
import ViewReadyDispatchOrderDetails from "pages/Warehouse/Dispatch/ReadyForDispatch/ViewDetails/ViewOrderDetails";
import StockTransferForm from "pages/Warehouse/Dispatch/StockTransfer/Form/StockTransferForm";
import StockTransferDetails from "pages/Warehouse/Dispatch/StockTransfer/ViewDetails/StockTransferViewDetails";
import LabourInwardGNR from "pages/Warehouse/ItemInward2/CreateGRN/LabourInwardGNR";
import SalesOrderReturnGNRForm from "pages/Warehouse/ItemInward2/CreateGRN/SalesOrderReturnGNR";
import StockTranferGRN from "pages/Warehouse/ItemInward2/CreateGRN/StockTransferGRN";
import EditStockTransferGRN from "pages/Warehouse/ItemInward2/EditGRN/EditStockTransferGRN";
import { default as SupplierGRN, default as WarehouseCreateGRN } from "pages/Warehouse/ItemInward2/CreateGRN/SupplierGRN";
import EditLabourInwardGNR from "pages/Warehouse/ItemInward2/EditGRN/EditLabourInwardGRN";
import EditSalesOrderReturnGNR from "pages/Warehouse/ItemInward2/EditGRN/EditSalesOrderReturnGNR";
import GRNViewDetails from "pages/Warehouse/ItemInward2/GRNDetails/GRNViewDetails";
import StockTransferInwardDetails from "pages/Warehouse/ItemInward2/GRNDetails/StockTransferInwardDetails";
import ItemInwardContainer from "pages/Warehouse/ItemInward2/Listing/ItemInwardContainer";
import ProjectWarehouse from "pages/Warehouse/Project Warehouse";
import InStockViewDetails from "pages/Warehouse/Project Warehouse/InStock/InStockViewDetails";

const WarehouseRoutes: any = [

  // Warehouse Overview Routes are starts from here
  {
    path: "/warehouse-overview",
    name: "Project Warehouse",
    component: <ProjectWarehouse />,
    permissions: {
      app_name: app_modules.warehouse.app_name,
      module_name: app_modules.warehouse.modules.warehouse_overview,
      action: action_options?.view,
    },
  },

  // Warehouse Overview > View Warehouse InStock
  {
    path: "/warehouse-overview/view-warehouse-in-stock/:master_item_id/:warehouse_id",
    name: "View Warehouse InStock",
    component: <InStockViewDetails />,
    permissions: {
      app_name: app_modules.warehouse.app_name,
      module_name: app_modules.warehouse.modules.warehouse_overview,
      action: action_options?.view,
    },
  },



 


  // Item Inward Routes starts from here
  {
    path: "/warehouse-item-inward",
    name: "Warehouse Item Inward",
    component: <ItemInwardContainer />,
    permissions: {
      app_name: app_modules.warehouse.app_name,
      module_name: app_modules.warehouse.modules.item_inward,
      action: action_options?.view,
    },
  },
  
  // Inward Stock Transfer
  {
    path: "/warehouse-stock-transfer-item-inward-grn/:dispatch_id",
    name: "Warehouse Stock Transfer Create GRN Form",
    component: <StockTranferGRN />,
    permissions: {  
      app_name: app_modules.warehouse.app_name,
      module_name: app_modules.warehouse.modules.item_inward,
      action: action_options?.create,
    },
  },
  {
    path: "/warehouse-stock-transfer-item-inward-edit-grn/:id",
    name: "Warehouse Stock Transfer Edit GRN Form",
    component: <EditStockTransferGRN />,
    permissions: {
      app_name: app_modules.warehouse.app_name,
      module_name: app_modules.warehouse.modules.item_inward,
      action: action_options?.update,
    },
  },
  // Inward Labour Inward
  {
    // path: "/warehouse-labour-item-inward-grn/",
    path: "/warehouse-labour-item-inward-grn/:id",
    name: "Warehouse Labour Inward Create GRN Form",
    component: <LabourInwardGNR />,
    permissions: {
      app_name: app_modules.warehouse.app_name,
      module_name: app_modules.warehouse.modules.item_inward,
      action: action_options?.create,
    },
  },
  // Inward Labour Edit
  {
    // path: "/warehouse-labour-item-inward-grn/",
    path: "/warehouse-labour-item-inward-grn-edit/:id",
    name: "Warehouse Labour Inward Create GRN Form",
    component: <EditLabourInwardGNR />,
    permissions: {
      app_name: app_modules.warehouse.app_name,
      module_name: app_modules.warehouse.modules.item_inward,
      action: action_options?.create,
    },
  },
  // Inward Sales order return
  {
    path: "/warehouse-sales-return-item-inward-grn/:dispatch_id",
    name: "Warehouse Sales Return Item Inward Create GRN Form",
    component: <SalesOrderReturnGNRForm />,
    permissions: {
      app_name: app_modules.warehouse.app_name,
      module_name: app_modules.warehouse.modules.item_inward,
      action: action_options?.create,
    },
  },
  {
    path: "/warehouse-sales-return-edit-item-inward-grn/:id",
    name: "Warehouse Sales Return Item Inward Edit GRN Form",
    component: <EditSalesOrderReturnGNR />,
    permissions: {
      app_name: app_modules.warehouse.app_name,
      module_name: app_modules.warehouse.modules.item_inward,
      action: action_options?.update,
    },
  },
  // Supplier Inward GRN Edit (must come before create route)
  {
    path: "/warehouse-item-inward-create-grn/:id",
    name: "Warehouse Item Inward Edit GRN Form",
    component: <WarehouseCreateGRN />,
    permissions: {
      app_name: app_modules.warehouse.app_name,
      module_name: app_modules.warehouse.modules.item_inward,
      action: action_options?.create,
    },
  },
  // Supplier Inward GRN Create
  {
    path: "/warehouse-item-inward-create-grn",
    name: "Warehouse Item Inward Create GRN Form",
    component: <SupplierGRN />,
    permissions: {
      app_name: app_modules.warehouse.app_name,
      module_name: app_modules.warehouse.modules.item_inward,
      action: action_options?.create,
    },
  },
  // View GRN Details
  {
    path: "/warehouse-grn-details/:id",
    name: "Warehouse Item Inward GRN Details",
    component: <GRNViewDetails />,
    permissions: {
      app_name: app_modules.warehouse.app_name,
      module_name: app_modules.warehouse.modules.item_inward,
      action: action_options?.view,
    },
  },

  // Warehouse > Item Inward > Stock Transfer Inward > View Details
  {
    path: "/warehouse-stock-transfer-inward-details/:id",
    name: "Warehouse Stock Transfer Inward Details",
    component: <StockTransferInwardDetails />,
    permissions: {
      app_name: app_modules.warehouse.app_name,
      module_name: app_modules.warehouse.modules.item_inward,
      action: action_options?.view,
    },
  },






  // Dispatch Routes are starts from here

  {
    path: "/warehouse-create-ready-for-dispatch",
    name: "Warehouse Ready For Dispatch Form",
    component: <WarehouseReadyForDispatchForm />,
    permissions: {
      app_name: app_modules.warehouse.app_name,
      module_name: app_modules.warehouse.modules.dispatch,
      action: action_options?.view,
    },
  },

  // Warehouse > Dispatch Routes
  {
    path: "/warehouse-dispatch",
    name: "Warehouse Dispatch",
    component: <DispatchContainer />,
    permissions: {
      app_name: app_modules.warehouse.app_name,
      module_name: app_modules.warehouse.modules.dispatch,
      action: action_options?.view,
    },
  },

  // Warehouse > Dispatch > Issue to Labour create Dispatch
  {
    path: "/warehouse-dispatch/IssueToLabour/create-dispatch-labour",
    name: "Warehouse Dispatch create dispatch to Labour",
    component: <IssueToLabourForm />, // Change to view details component
    permissions: {
      app_name: app_modules.warehouse.app_name,
      module_name: app_modules.warehouse.modules.dispatch,
      action: action_options?.create,
    },
  },

  // Warehouse > Dispatch > create Stock Transfer
  {
    path: "/warehouse-dispatch/stockTransfer/create-stock-transfer",
    name: "Warehouse Dispatch create Stock Transfer",
    component: <StockTransferForm />, // Change to view details component
    permissions: {
      app_name: app_modules.warehouse.app_name,
      module_name: app_modules.warehouse.modules.dispatch,
      action: action_options?.create,
    },
  },

  // Warehouse > Dispatch > Ready For Dispatch > Create Dispatch 
  {
    path: "/warehouse-dispatch/ready-for-dispatch/create-dispatch/:order_id",
    name: "Warehouse Dispatch Ready for disptach create dispatch",
    component: <WarehouseReadyForDispatchForm />, // Change to view details component
     permissions: {
      app_name: app_modules.warehouse.app_name,
      module_name: app_modules.warehouse.modules.dispatch,
      action: action_options?.create,
    },
  },
  {
    path: "/warehouse-dispatch/ready-for-dispatch/edit-dispatch/:order_id/:dispatch_id",
    name: "Warehouse Dispatch Ready for disptach edit dispatch",
    component: <WarehouseReadyForDispatchEditForm />, // Change to view details component
     permissions: {
      app_name: app_modules.warehouse.app_name,
      module_name: app_modules.warehouse.modules.dispatch,
      action: action_options?.update,
    },
  },
  {
    path: "/warehouse-dispatch/ready-for-dispatch/view-details/:id",
    name: "Warehouse Dispatch Ready for disptach view details",
    component: <ViewReadyDispatchOrderDetails />, // Change to view details component
     permissions: {
      app_name: app_modules.warehouse.app_name,
      module_name: app_modules.warehouse.modules.dispatch,
      action: action_options?.update,
    },
  },

  // Warehouse > Dispatch > Dispatch > View Details
  {
    path: "/warehouse-dispatch/dispatch/view-details/:dispatch_id",
    name: "Warehouse Dispatch Dispatch view Deatils",
    component: <DispatchViewDetails />, // Change to view details component
    permissions: {
      app_name: app_modules.warehouse.app_name,
      module_name: app_modules.warehouse.modules.dispatch,
      action: action_options?.view,
    },
  },

  // Warehouse > Dispatch > Dispatch > Sales Order Return
  {
    path: "/warehouse-dispatch/dispatch/sales-order-return/:dispatch_id",
    name: "Warehouse Dispatch Sales Order Return",
    component: <SalesOrderReturn />,
    permissions: {
      app_name: app_modules.warehouse.app_name,
      module_name: app_modules.warehouse.modules.dispatch,
      action: action_options?.update,
    },
  },

  
   // Warehouse > Dispatch > Dispatch > Edit Form
  {
    // path: "/warehouse-dispatch/dispatch/edit-dispatch/:id",
    path: "/warehouse-dispatch/dispatch/edit-dispatch",
    name: "Warehouse Dispatch dispatch Edit Form",
    component: <StockTransferForm />, // Change to Edit details component
    permissions: {
      app_name: app_modules.warehouse.app_name,
      module_name: app_modules.warehouse.modules.dispatch,
      action: action_options?.update,
    },
  },

  // Warehouse > Dispatch > Stock Transfer > View Details
  {
    path: "/warehouse-dispatch/StockTransfer/view-details/:id",
    name: "Warehouse Dispatch Stock Transfer view Deatils",
    component: <StockTransferDetails />, // Change to view details component
    permissions: {
      app_name: app_modules.warehouse.app_name,
      module_name: app_modules.warehouse.modules.dispatch,
      action: action_options?.view,
    },
  },

   // Warehouse > Dispatch > Stock Transfer > Edit Form
  {
    path: "/warehouse-dispatch/stockTransfer/edit-stockTransfer/:id",
    name: "Warehouse Dispatch Stock Transfer Edit Form",
    component: <StockTransferForm />, // Change to Edit details component
    permissions: {
      app_name: app_modules.warehouse.app_name,
      module_name: app_modules.warehouse.modules.dispatch,
      action: action_options?.update,
    },
  },

  // Warehouse > Dispatch > Issue to Labour > view details page
  {
    path: "/warehouse-dispatch/IssueToLabour/view-details/:id",
    name: "Warehouse Dispatch Issue to Labour View Details",
    component: <IssueToLabourViewDetails />, // Change to view details component
    permissions: {
      app_name: app_modules.warehouse.app_name,
      module_name: app_modules.warehouse.modules.dispatch,
      action: action_options?.view,
    },
  },

   // Warehouse > Dispatch > Issue to Labour > Edit Form page
  {
    path: "/warehouse-dispatch/IssueToLabour/edit-issueToLabour/:id",
    name: "Warehouse Dispatch Issue to Labour Edit Form",
    component: <IssueToLabourForm />, // Change to view details component
    permissions: {
      app_name: app_modules.warehouse.app_name,
      module_name: app_modules.warehouse.modules.dispatch,
      action: action_options?.update,
    },
  },
  
];

export default WarehouseRoutes;
